import React, { useState } from "react";
import "../styles/ReturningUserPage.css";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setErrorMessage("");

    // simple email check to replace native validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!isValidEmail) {
      setErrorMessage("please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("https://squid-app-6s2hc.ondigitalocean.app/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();

      if (data.success) {
        setMessage(data.message);
        setSubmitted(true);
      } else {
        setErrorMessage(data.message || "An error occurred.");
      }
    } catch {
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="forgot-password-page">
       <div className="returning-wrap">

      {/* noValidate disables native HTML5 popups */}
      <form onSubmit={handleForgotPassword} className="forgot-password-form" noValidate>
        <div className="input-group">
          <label htmlFor="email" className="sr-only">email:</label>
          <input
            id="email"
            type="email"                 /* keeps email keyboard on mobile */
            autoComplete="email"
            inputMode="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErrorMessage(""); setMessage(""); }}
            placeholder="enter your email"
            className={errorMessage ? "has-error" : ""}
            aria-invalid={!!errorMessage}
            aria-describedby={errorMessage ? "email-error" : undefined}
          />
        </div>

        {(errorMessage || message) && (
          <p
            className={`status-message ${errorMessage ? "is-error" : "is-success"}`}
            role="status"
            aria-live="polite"
          >
            {errorMessage || message}
          </p>
        )}

        <button
          type="submit"
          className="submit-button"
          disabled={loading || submitted}
        >
          {loading ? "sending..." : submitted ? "email sent" : "reset my password"}
        </button>
      </form>
    </div>
    </main>
  );
};

export default ForgotPasswordPage;
